"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const buttonStyle = {
    padding: '5px 20px',
    fontSize: 'small',
    backgroundColor: '#ff6702',
    color: '#fff',
    border: '1px solid #ff6702',
    cursor: 'pointer'
};
const iconStyle = {
    cursor: 'pointer'
};
const clickableStyle = disable => ({
    cursor: disable ? 'not-allowed' : 'pointer'
});
exports.default = {
    buttonStyle,
    iconStyle,
    clickableStyle
};
